import { uniq } from 'lodash';
import { Component, Prop, Vue, State } from 'nuxt-property-decorator';
import { IMainLocation } from '~/types/region';


@Component({

})
export default class extends Vue {

    @Prop()
    public cities;

    public opened = false;

    public searchQuery = '';

    @Prop() value!: string;
    @State region!: IMainLocation;

    $refs: {
        inputField: HTMLInputElement
    }

    async openDropdown() {
        this.opened = true;
        this.searchQuery = '';
        await this.$nextTick();
        this.$refs['inputField'].focus();
    }

    selectCity(code: string) {
        this.$emit('input', code);
        this.opened = false;
    }

    get currentCity() {
        return this.cities.find((el) => el.code === this.value);
    }

    get dropdownCities() {

        let search = this.searchQuery.trim().toLowerCase();

        if (search.length) {

            return uniq([
                ...this.cities.filter((el) => el.name.toLowerCase().includes(search)),
                ...this.cities.filter((el) => el.region && el.region.toLowerCase().includes(search))
            ]);
        }

        return uniq([this.currentCity, ...this.cities.filter((el) => el.top)])
    }
}
